import { computed } from 'vue'
import { createQuery } from '@/queries'
import { getAvailableColors } from '@/features/my-style/api/my-style'
import type { AvailableColor } from '@/types/my-style'
import type { AxiosResponse } from 'axios'

type AvailableColorsResponse = Awaited<
  ReturnType<typeof getAvailableColors>
> extends AxiosResponse<infer T>
  ? T
  : never

export const useAvailableColorsQuery = () => {
  return createQuery<AvailableColorsResponse>({
    key: computed(() => ['available-colors']),
    fetcher: async () => {
      const response = await getAvailableColors()
      return response.data
    },
    staleTime: 10 * 60 * 1000, // 10 minutes
    enabled: computed(() => true)
  })
}

